import request from '@/utils/request'
const baseExaminationUrl = '/exam/examActivityEntry/'
const baseExaminationUrl2 = '/exam/examRaceActivity/'

// 中北PC端参加活动接口
export function addObj (obj) {
  return request({
    url: baseExaminationUrl +'add',
    method: 'post',
    data: obj
  })
}
//中北PC端报名活动列表
export function fetchList (query) {
  return request({
    url: baseExaminationUrl2 + 'listForPC',
    method: 'get',
    params: query
  })
}

// 中北PC端报名待修改列表
export function fetchListForModify (query) {
  return request({
    url: baseExaminationUrl + 'listForModify',
    method: 'get',
    params: query
  })
}

// 中北pc端修改活动接口
export function updateObj (obj) {
  return request({
    url: baseExaminationUrl +'update',
    method: 'post',
    data: obj
  })
}

// 中北PC端活动详情
export function fetchDetail (query) {
  return request({
    url: baseExaminationUrl2 + 'selectOne',
    method: 'get',
    params:  query 
  })
}

//中北PC端活动报名详情
export function getSignupDetail (query) {
  return request({
    url: baseExaminationUrl + 'selectOne',
    method: 'get',
    params:  query 
  })
}

// 赛事沟通群列表
export function getInteractGroupList (query) {
  return request({
    url: '/exam/examInteractGroup/list',
    method: 'get',
    params: query
  })
}
// 赛事沟通群详情
export function getInteractGroupDetail (query) {
  return request({
    url: '/exam/examInteractGroup/selectOne',
    method: 'get',
    params: query
  })
}